import { useState } from 'react';

import { IonIcon, IonText, IonImg } from '@ionic/react';
import { informationCircleOutline } from 'ionicons/icons';

import { getUrlFromPath } from 'libs/helpers/helper.lib';

import CustomModal from 'components/CustomModal';

import classes from './style.module.scss';

const FuelingInfoContainer = ({ fuelingPlan }) => {
  const [showPopover, setShowPopover] = useState(false);

  return (
    <div className={classes.programTitleHead}>
      <IonImg
        src={getUrlFromPath(fuelingPlan.cover)}
        alt={fuelingPlan.name}
        className={classes.image}
      />
      <div className={classes.fuelingPlanInfoContainer}>
        <div className={classes.fuelingPlanCategory}>
          <IonText className='big'>
            {fuelingPlan.fuelingPlanCategory.name}
          </IonText>
        </div>
        <div className={classes.fuelingPlanNameNotes}>
          <IonText className='big'>{fuelingPlan.name}</IonText>
          <IonIcon
            size='large'
            icon={informationCircleOutline}
            onClick={(e) => {
              e.stopPropagation();
              setShowPopover(true);
            }}
          />
          <CustomModal
            isOpen={showPopover}
            dismiss={() => setShowPopover(false)}
            title='Notes'
            content={fuelingPlan.notes}
          />
        </div>
      </div>
    </div>
  );
};

export default FuelingInfoContainer;
